import toast from "react-hot-toast"

const successNotify = (
  message: string, 
  position: any = 'top-right'
) => toast.success(message, { 
  position: position
})

const errorNotify = (
  message: string, 
  position: any = 'top-right'
) => toast.error(message, { 
  position: position,
  style: {
    borderRadius: '10px',
    color: '#fff',
    background: '#dc3545'
  },
})

const warningNotify = (
  message: string, 
  position: any = 'top-right'
) => toast(message, { 
  position: position,
  icon: '❕',
  style: {
    borderRadius: '10px',
    background: '#ffc107'
  },
})

export {
  successNotify,
  errorNotify,
  warningNotify
}